import styled from '@emotion/styled'

export const SuccessModalTitle = styled.div`
  font-family: Roboto;
  font-size: 30px;
  font-weight: 300;
  text-align: center;
`
